import React, { useState, useEffect } from 'react';
import {FiChevronRight } from 'react-icons/fi';
import { visualizeAllGists } from '../Utils/githubConfig';
import Navbar from './Navbar';
import { Link, useNavigate } from 'react-router-dom';
import './Reports.css';

const Reports = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  useEffect(() => {
    const fetchReports = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await visualizeAllGists();
        if (!data || data.length === 0) {
          setError('No reports found');
          return;
        }
        setReports(data);
      } catch (err) {
        console.error('Error:', err);
        setError(err.message || 'Failed to fetch reports. Please check your network connection.');
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  const viewPatientDetails = (report) => {
    navigate(`/hospital/reports/patient-details`, { state: { report } });
  };

  if (loading) {
    return (
      <div className="admin-layout">
        <Navbar />
        <main className="admin-main">
          <div className="admin-header">
            <div className="admin-welcome-section">
              <div className="breadcrumb">
                <Link to="/dashboard">Admin Dashboard</Link>
                <FiChevronRight className="breadcrumb-separator" />
                <Link to="/dashboard/reports">Reports</Link>
              </div>
              <h1>Patient Reports</h1>
              <p>View and analyze patient test reports</p>
            </div>
          </div>
          <div className="reports-container">
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <div className="loading-text">Loading Reports...</div>
            </div>
          </div>
        </main>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-layout">
        <Navbar />
        <main className="admin-main">
          <div className="admin-header">
            <div className="admin-welcome-section">
              <div className="breadcrumb">
                <Link to="/dashboard">Admin Dashboard</Link>
                <FiChevronRight className="breadcrumb-separator" />
                <Link to="/dashboard/reports">Reports</Link>
              </div>
              <h1>Patient Reports</h1>
              <p>View and analyze patient test reports</p>
            </div>
          </div>
          <div className="reports-container">
            <div className="error">{error}</div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="admin-layout">
      <Navbar />
      <main className="admin-main">
        <div className="admin-header">
          <div className="admin-welcome-section">
            <div className="breadcrumb">
              <Link to="/dashboard">Admin Dashboard</Link>
              <span className="separator">•</span>
              <Link to="/dashboard/reports">Reports</Link>
            </div>
            <h1>Patient Reports</h1>
            <p>View and analyze patient test reports</p>
          </div>
        </div>

        <div className="reports-container">
          <div className="reports-grid">
            {reports.map((report, index) => (
              <div className="report-card" key={index}>
                <div className="report-header">
                  <h3>{report.name}</h3>
                  <span className="report-date">
                    Created on: {formatDate(report.createdAt)}
                  </span>
                </div>
                <div className="report-content">
                  <div className="info-row">
                    <span className="info-label">Patient ID:</span>
                    <span className="info-value">{report.patientId}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Age:</span>
                    <span className="info-value">{report.age || "N/A"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Sex:</span>
                    <span className="info-value">{report.sex || "N/A"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Tests:</span>
                    <span className="info-value">
                      {report.cmgTests ? report.cmgTests.length : 0}
                    </span>
                  </div>
                </div>
                <button 
                  className="view-details-btn"
                  onClick={() => viewPatientDetails(report)}
                >
                  Details
                </button>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Reports;